import { render, staticRenderFns } from "./PaidTier.vue?vue&type=template&id=98f4451a&scoped=true&"
import script from "./PaidTier.vue?vue&type=script&lang=js&"
export * from "./PaidTier.vue?vue&type=script&lang=js&"
import style0 from "./PaidTier.vue?vue&type=style&index=0&id=98f4451a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f4451a",
  null
  
)

export default component.exports